import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconVoicemail = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--voicemail")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M18.5,6 C21.5375661,6 24,8.46243388 24,11.5 C24,14.5375661 21.5375661,17 18.5,17 L5.5,17 L5.5,17 C2.46243388,17 0,14.5375661 0,11.5 C0,8.46243388 2.46243388,6 5.5,6 C8.53756612,6 11,8.46243388 11,11.5 C11,12.8298843 10.5280013,14.0495273 9.74238585,15.0005473 L14.2576141,15.0005473 C13.4719987,14.0495273 13,12.8298843 13,11.5 C13,8.46243388 15.4624339,6 18.5,6 Z M5.5,8 C3.56700338,8 2,9.56700338 2,11.5 C2,13.4329966 3.56700338,15 5.5,15 C7.43299662,15 9,13.4329966 9,11.5 C9,9.56700338 7.43299662,8 5.5,8 Z M18.5,8 C16.5670034,8 15,9.56700338 15,11.5 C15,13.4329966 16.5670034,15 18.5,15 C20.4329966,15 22,13.4329966 22,11.5 C22,9.56700338 20.4329966,8 18.5,8 Z" id="icon--centivo--voicemail"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1767.000000, -1312.000000)"/>
          <g id="Icon/voicemail">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--voicemail"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--voicemail"/>
          </g>
      </g>
  </IconWrapper>
)
